import styled from "styled-components";
import { theme } from "../../theme";

export const StyledDropDown = styled.div<{ value: string }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 16px;
  position: relative;
  label {
    font-size: 14px;
    margin-bottom: 5px;
    font-weight: 500;
  }

  select {
    outline: none;
    border: none;
    background-color: ${theme.backgroundColor.primaryWhite};
    color: ${({ value }) =>
      value ? theme.textColor.primaryBlack : theme.textColor.secondaryGray};
    padding: 10px;
    border: 2px solid ${theme.backgroundColor.primaryGray};
    font-size: 16px;
    font-weight: 500;
    option {
      color: ${theme.textColor.primaryBlack};
    }
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`;
